module.exports = __webpack_public_path__ + "img/quotation.57cb152a.png";